var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "relative overflow-x-auto"
  }, [_c('div', {
    staticClass: "text-sm flex-col text-center"
  }, [_c('table', {
    staticClass: "table-auto w-full text-sm text-left text-gray-500 dark:text-white"
  }, [_vm._m(0), _c('tbody', _vm._l(_vm.orderdetail.paymentinappbillings, function (orderpayment, index) {
    return _c('tr', {
      key: orderpayment.id,
      staticClass: "bg-white border-b dark:bg-gray-900 dark:border-gray-700"
    }, [_c('td', {
      staticClass: "py-2 px-2 text-gray-500"
    }, [_vm._v(" " + _vm._s(index + 1) + " ")]), _c('td', {
      staticClass: "py-2 px-2 text-gray-500"
    }, [_vm._v(" " + _vm._s(_vm.formatDate(orderpayment.created)) + " ")]), _c('td', {
      staticClass: "py-2 px-2 text-gray-500"
    }, [_vm._v(" " + _vm._s(orderpayment.status) + " ")]), _c('td', {
      staticClass: "py-2 px-2 text-gray-500 w-44"
    }, [_vm._v(" " + _vm._s(orderpayment !== null && orderpayment !== void 0 && orderpayment.purchase_token ? orderpayment === null || orderpayment === void 0 ? void 0 : orderpayment.purchase_token : 'PurchaseToken Notfound') + " "), orderpayment !== null && orderpayment !== void 0 && orderpayment.purchase_token ? _c('button', {
      attrs: {
        "size": "sm",
        "variant": "outline"
      },
      on: {
        "click": function ($event) {
          return _vm.copyTextToClipboard(orderpayment.purchase_token);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-copy"
    })]) : _vm._e()]), _c('td', {
      staticClass: "py-2 px-2 text-gray-500"
    }, [_vm._v(" " + _vm._s(orderpayment !== null && orderpayment !== void 0 && orderpayment.iab_order_id ? orderpayment === null || orderpayment === void 0 ? void 0 : orderpayment.iab_order_id : 'GPA Order Not Found') + " ")])]);
  }), 0), _vm.orderdetail.paymentinappbillings.length === 0 ? _c('tbody', [_vm._m(1)]) : _vm._e()])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', {
    staticClass: "text-xs uppercase bg-gray-200 dark:bg-gray-800 dark:text-gray-400"
  }, [_c('tr', [_c('th', {
    staticClass: "px-2 py-3",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("No")]), _c('th', {
    staticClass: "px-2 py-3",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Payment Time")]), _c('th', {
    staticClass: "px-2 py-3",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Status")]), _c('th', {
    staticClass: "px-2 py-3",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Purchase Token")]), _c('th', {
    staticClass: "px-2 py-3",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("IAB Order ID")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('td', {
    attrs: {
      "colspan": "15"
    }
  }, [_c('p', {
    staticClass: "text-sm text-gray-500 text-center mt-2"
  }, [_vm._v("There are no records to show")])]);
}]

export { render, staticRenderFns }